// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--2d913";
export var layout = "Footer-module--layout--17146";
export var logo = "Footer-module--logo--2eef9";
export var info = "Footer-module--info--fb109";
export var address = "Footer-module--address--e79cb";
export var contacts = "Footer-module--contacts--01560";
export var navigation = "Footer-module--navigation--6d64c";
export var link = "Footer-module--link--e0d8f";
export var copyright = "Footer-module--copyright--a775b";
export var showMobile = "Footer-module--showMobile--ddc3f";
export var showTablet = "Footer-module--showTablet--7fd97";